import React from 'react';
import { motion } from 'framer-motion';
import { ArrowRight } from 'lucide-react';
import { semanticCapabilities } from '../data/semanticKnowledge';
import { fadeUp } from '../utils/motion';
import { PageHero } from '../components/layout/PageHero';
import { SkpLlmTeaser } from '../components/semantic/SkpLlmTeaser';
import { SkpWorkflow } from '../components/semantic/SkpWorkflow';
import { SkpResearch } from '../components/semantic/SkpResearch';
import { SkpCapabilityFoundation } from '../components/semantic/SkpCapabilityFoundation';
import { SkpControls } from '../components/semantic/SkpControls';
import { SkpFoundation } from '../components/semantic/SkpFoundation';
import { SkpCTA } from '../components/semantic/SkpCTA';
export function SemanticKnowledgePage() {
  return <>
      <PageHero eyebrow="Products" title="Semantic Knowledge Platform" lead="A configurable system for structured content, shared concepts, connected evidence, knowledge graphs, semantic search, and AI-assisted research." body={['It turns scattered research and content into connected, usable knowledge — defining concepts and relationships, linking evidence across sources, and pairing AI-assisted discovery with expert review.']} data-id="element-1927" data-mp="qyeffx6oqyej">
        <div className="mt-8 flex flex-col sm:flex-row sm:items-center gap-4 sm:gap-8" data-id="element-1928" data-mp="k0w7xprlscdx">
          <a href="/contact" className="inline-flex items-center justify-center gap-2 bg-navy hover:bg-navy-light text-white font-semibold px-6 py-3.5 rounded-md transition-colors duration-150 whitespace-nowrap" data-id="element-1929" data-mp="k38xanzoxp10">
            Request a Demo
            <ArrowRight size={18} aria-hidden="true" data-id="element-1930" data-mp="17x0kb1om0ut0" />
          </a>
          <a href="#how-it-works" onClick={event => {
          event.preventDefault();
          document.getElementById('how-it-works')?.scrollIntoView({
            behavior: 'smooth',
            block: 'start'
          });
        }} className="inline-flex items-center gap-2 text-navy font-semibold hover:text-navy-light transition-colors duration-150 whitespace-nowrap" data-id="element-1931" data-mp="12ypa2puekia9">
            See how it works
          </a>
        </div>
      </PageHero>

      <section className="bg-surface-bg py-20 lg:py-28" data-id="element-1932" data-mp="3g6ylsntawnld">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 grid grid-cols-1 lg:grid-cols-12 gap-10 lg:gap-16" data-id="element-1933" data-mp="3g4cempaboa3o">
          <motion.h2 {...fadeUp} className="lg:col-span-4 font-heading font-bold text-4xl lg:text-5xl text-ink-dark tracking-tight leading-tight" data-id="element-1934" data-mp="3l36w9nwjzsm7">
            What the platform brings together
          </motion.h2>
          <motion.dl {...fadeUp} className="lg:col-span-8 grid grid-cols-1 md:grid-cols-2 gap-x-12 border-t border-line" data-id="element-1935" data-mp="2x8m7yorg2pjg">
            {semanticCapabilities.map(item => <div key={item.title} className="border-b border-line py-7" data-id="element-1936" data-mp="vhivrv1wp2ws">
                <dt className="font-heading font-bold text-xl text-ink-dark mb-2" data-id="element-1937" data-mp="10fkicpyjjkd0">{item.title}</dt>
                <dd className="text-ink-muted leading-relaxed" data-id="element-1938" data-mp="2kwjywm2bu8p6">{item.body}</dd>
              </div>)}
          </motion.dl>
        </div>
      </section>

      <SkpLlmTeaser data-id="element-1939" data-mp="2fwfgurlrt5wu" />
      <SkpWorkflow data-id="element-1940" data-mp="2unobxg8fzjhd" />
      <SkpResearch data-id="element-1941" data-mp="2uo7sotmcw1tt" />
      <SkpCapabilityFoundation data-id="element-1942" data-mp="2uopm7ihmw1y1" />
      <SkpControls data-id="element-1943" data-mp="2pwg1cgvdls2m" />
      <SkpFoundation data-id="element-1944" data-mp="2pvwj0z1td1o2" />
      <SkpCTA data-id="element-1945" data-mp="2pven63j2cpgo" />
    </>;
}